// eslint-disable-next-line import/prefer-default-export
export const REQUEST_SUPER6EXTRA_ACTIVE_ROUND =
    'super6Extra/REQUEST_SUPER6EXTRA_ACTIVE_ROUND';
export const RECEIVE_SUPER6EXTRA_ACTIVE_ROUND =
    'super6Extra/RECEIVE_SUPER6EXTRA_ACTIVE_ROUND';
